import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ItemFormat } from "./models/itemFormat.model";
import { Observable, BehaviorSubject } from "rxjs";
import { CompanyInfo, ConnectionInfo } from "./models/config-data.model"
import { tap } from "rxjs/operators";
import { CustomerFormat } from "./models/customerFormat.model";


import { environment } from "../../environments/environment";

export interface AddContactInformationParams {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    address: string;
    zip: string;
    city: string;
    state: string;
    promo: string;
}

export interface UpdateQuote{
    appNumber: string;
    lastName: string;
    firstName: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    coverage: string;
    cuscost: string;
    downpay: string;
    listCode: string;
    listCode2: string;
    promo: string;

    email: string;
    gensur1: string;
    dispcode: string;
    salesman: string;
}

export interface GetContactInformationParams {
    appNumber: any;
}  

export interface AddContactInformationResponse {
    added: boolean;
    idContact: number;
}

export interface updateSales2  {
    lastName: string;
    firstName: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    email: string;
    coverage: string;
    appNumber: string;
    promo: string;
    listCode: string;
    listCode2: string;
    cuscost: string;
    downpay: string;
    term: string;
    deduct: string;
    gensur1: string;

}

export interface payment{
    amount: number,
    description: string,
    cardHolder: string,
    cardNumber: any,
    cardExp: any,
    invoice: string;
}

export interface TermsAndConditions{
    appNumber: string;
    agreedToAllTermsAndConditions: boolean,
    consentToCall: boolean,
    sessionIPAddress: string;
}

export interface UserLookup {
    companyID: number;
    appNumber: string;
}

export interface getLeadDataResponseItem {
    responseCode: string,
    responseDescription: string,
    quoteDetail: {
        payMeth: string,
        year: string,
        make: string,
        makeDescription: string,
        model: string,
        vin: string,
        odometer: string,
        soldDate: string,
        cover: string,
        term: string,
        deductible: string,
        cost: string,
        retailCost: string,
        taxRate: string,
        financeTerm: string,
        downPay: string,
        lastName: string,
        firstName: string,
        rateState: string,
        termInMonths: string,
        address: string,
        city: string,
        state: string,
        zip: string,
        phone: string,
        email: string,
        promo: string,
        proLogo: string,
        proName: string,
        coverageDescription: string,
        passKey: string,
        gfSalesmanID: string,
        gfTOID: string,
        gfVerID: string,
        firstBillDate: string,
        commercial: string,
        dually: string,
        overSizedTires: string,
        conversionVan: string,
        liftKit: string,
        snowPlow: string,
        lienholder: string,
        secondName: string
    }

}


@Injectable({
    providedIn: 'root'
})
// implements OnInit
export class DirectApiService  {
    constructor(
        private readonly http: HttpClient, 
    ) { 
        this.initConfigs(); 
        
    }

    itemList: ItemFormat[] = [];
    connectionInfo: ConnectionInfo = {} as ConnectionInfo;
    companyInfo: CompanyInfo = {} as CompanyInfo;
    storedCustomerDetails: CustomerFormat = {} as CustomerFormat;

    private companyName: string = "";
    private companyId: number = 0;
    private saleEndpoint: string = "";

    private apiUrl: string = "";


    couponUrl: string = '/validateCoupon';

    loadingMsgSubject = new BehaviorSubject<string>('');
    $loadingMsg = this.loadingMsgSubject.asObservable();


    // getMarketingItems() {
    //     this.http.get<ItemFormat[]>(`${this.apiUrl}/marketingItems`)
    //     .pipe(
    //         map(data => data.map(item => new ItemFormat(item))))
    //     .subscribe(data => {
    //         this.itemList = data;
    //         return data;
    //     });
    // }

    initConfigs() {
        this.connectionInfo = environment.ConnectionInfo;
        this.companyInfo = environment.CompanyInfo;
        this.companyId = this.companyInfo.CompanyId;
        this.companyName = this.companyInfo.CompanyName;
        this.saleEndpoint = this.companyInfo.SaleEndpoint;
        this.apiUrl = environment.ConnectionInfo.apiUrl.toString() + 'api/';
    }

    addContactInformation(req: AddContactInformationParams): Observable<AddContactInformationResponse> {
        console.log("Add Contact companyId: " + this.companyId);

        return this.http.post<any>(this.apiUrl + 'ForteCrm/AddContactInformation', null, { 
            params: {
                ...req,
                companyId: this.companyId
        } });
    }

    updateQuote(quote: UpdateQuote): Observable<any> {
        return this.http.post<any>(this.apiUrl + 'ForteCrm/UpdateQuote', { request: quote, companyId: this.companyId });
    }

    updateSale(sale: updateSales2): Observable<any> {
        return this.http.post<any>(this.apiUrl + 'ForteCrm/UpdateSale', { request: sale, surchargeQuestions: '', companyId: this.companyId });
    }

    setPayment(paymentParams: payment, sale: updateSales2, planFriendlyName: string ): Observable<any> {
        this.setLoading( "Processing Payment...");

        const req =  { 
            cardHolder: paymentParams.cardHolder, 
            cardNumber: paymentParams.cardNumber, 
            cardExp: paymentParams.cardExp, 
            amount: paymentParams.amount, 
            invoice: ((Date.now() / 1000) | 0).toString().substring(0, 10),
            description: this.companyName + ' Transaction'
        };
        let ret = this.http.post<any>(this.apiUrl + 'ForteCrm/' + this.saleEndpoint, 
            { 
                request: req, 
                updateSales2: sale, 
                surchargeQuestions: null,
                companyId: this.companyId, 
                planFriendlyName: planFriendlyName 
            }).pipe(
                tap(
                    data => {
                        this.setLoading("");
                        return data;
                    }
                )
            );

        return ret;
    }

    postTermsAndConditions(terms: TermsAndConditions): Observable<any> {
        return this.http.post<any>(this.apiUrl + 'ForteCrm/PostTermsAndConditions', { request: '', shieldSafeRequest: terms, 
            companyId: this.companyId})
    }
    
    getIPAddress(): Observable<any> {
        return this.http.get<any>("https://api.ipify.org/?format=json");
    }
        
    // getAddressSuggestions(searchText: string): Observable<any> {
    //     const bingMapsKey = this.settingsService?.getSetting("bingMapsKey");
    //     const bingMapsKeyUrl = this.settingsService?.getSetting("bingMapsKeyUrl");
    //     return this.http.get<any>(bingMapsKeyUrl + searchText + '&o=json&key=' + bingMapsKey, { responseType: 'json' });
    // }

    
    getContactInfo(UserLookup: UserLookup): Observable<any> {
        this.setLoading( "Retreiving Data...");
        let companyIdToUse = 0;
        if(UserLookup.companyID > 0){
            companyIdToUse = UserLookup.companyID;
        }else{
            companyIdToUse = this.companyId;
        }

        let params = new HttpParams()
            .set('appNumber', UserLookup.appNumber)
            .set('companyId', companyIdToUse );

        let userData = this.http.get<any>(this.apiUrl + 'ForteCrm/GetLeadData', {params} ).pipe( 
            tap( 
                data => {
                    this.setLoading("");
                    return data;
                },
                error => {
                    this.setLoading("");
                    console.error("Error fetching customer data", error);
                }
            )
        );
        
        return userData;
    }

    setLoading( message?: string): void {
        let messageString = message ?? "";
        this.loadingMsgSubject.next(messageString);
    }

    getLoadingMsg(): Observable<string> {
        return this.$loadingMsg;
    }

    FetchCouponWithCode(couponCode: string): Observable<any> {
        let params = new HttpParams()
            .set('couponCode', couponCode)
            .set('companyID', this.companyId.toString());
        

        return this.http.get<any>(this.apiUrl + 'MiddleTier/FetchCoupon' , {params});
    }

    async fetchPlans(){
        await this.initConfigs();

        let params = new HttpParams()
            .set('companyID', this.companyId.toString())
            .set('identifier', 'default');     

        let items = this.http.get<any>(this.apiUrl + 'SiteConfig/FetchPlansConfig', {params}).pipe(
            tap(
                data => {
                    if (data.responseCode === "200") {
                        return data;
                    }
                    else if (data.responseCode === "204") {
                        console.log("No plans data found");
                        return {};
                    }else{
                        return data ;                        
                    }

                },
                error => {
                    console.error("Error fetching plans data", error);
                }
            )
        );

        return items; 
        //or should it just directly set them to the service?
    }

    async fetchFeatures(){
        await this.initConfigs();
        let params = new HttpParams()
            .set('companyID', this.companyId.toString())
            .set('identifier', 'default');

        let items = this.http.get<any>(this.apiUrl + 'SiteConfig/FetchFeatureConfig', {params}).pipe(
            tap(
                data => {
                    if (data.responseCode === "200") {
                        return data;
                    }
                    else if (data.responseCode === "204") {
                        console.log("No feature data found");
                        return {};
                    }else{
                        return data ;                        
                    }

                },
                error => {
                    console.error("Error fetching feature data", error);
                }
            )
        );
        
        return items; 
        //or should it just directly set them to the service?
    }

    async fetchSteps(){
        await this.initConfigs();
        let params = new HttpParams()
            .set('companyID', this.companyId.toString())
            .set('identifier', 'default');

        let items = this.http.get<any>(this.apiUrl + 'SiteConfig/FetchStepConfig', {params}).pipe(
            tap(
                data => {
                    if (data.responseCode === "200") {
                        return data;
                    }
                    else if (data.responseCode === "204") {
                        console.log("No Step data found");
                        return {};
                    }else{
                        return data ;                        
                    }

                },
                error => {
                    console.error("Error fetching Step data", error);
                }
            )
        );
        
        return items; 
        //or should it just directly set them to the service?
    }

    async fetchItems(){
        await this.initConfigs();
        let params = new HttpParams()
            .set('companyID', this.companyId.toString())
            .set('identifier', 'default');

        let items = this.http.get<any>(this.apiUrl + 'SiteConfig/FetchItemConfig', {params}).pipe(
            tap(
                data => {
                    if (data.responseCode === "200") {
                        return data;
                    }
                    else if (data.responseCode === "204") {
                        console.log("No Item data found");
                        return {};
                    }else{
                        return data ;                        
                    }

                },
                error => {
                    console.error("Error fetching Item data", error);
                }
            )
        );
        
        return items; 
        //or should it just directly set them to the service?
    }

}